/* eslint-disable no-unused-expressions */
import React, { Component } from 'react'
import { Button } from "shards-react";
import { FaAvianex } from "react-icons/fa";
import { connect } from 'react-redux'
//import Switch from "react-switch";
import fetchAllAircraftDataAction from "../lib/fetchAllAircraftData";
import {
    getAllAircraftError,
    getAllAircraft
  } from "../redux/reducers/rootReducer";

import "../assets/css/PilotListSettings.css"
import FlightList from "./sidebar_components/FlightList";


var sprintf = require('sprintf-js').sprintf;
    

class PilotList extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
             containerOpen: false,
        }
    }

    render() {
        const { theme  } = this.props

        const containerClasses = ['fsettingsContainer'];
        const buttonClasses = ['fsettingsButton'];
        const cardClasses = ['fsettingsCard'];

//        var lines = '<div><a href="//localhost">TEST 1</a></div><div>TEST 2</div>';

        if (this.state.containerOpen) {
          containerClasses.push("fsettingsContainerOpen");
          buttonClasses.push("fsettingsButtonOpen");
          cardClasses.push('fsettingsCardOpen')
        }

       
        return (
          <div className={containerClasses.join(" ")}>
            <Button style={{backgroundColor: theme.accent, borderColor: theme.accent}} className={buttonClasses.join(" ")} onClick={() => this.setState({ containerOpen: !this.state.containerOpen })}>
              <FaAvianex fontSize={22} />
              <div>
                <p>Pilots online</p>
              </div>
            </Button>
            <div className={"rsidebar"} style={{backgroundColor: theme.secondary}}>
            <div style={{color: theme.textPrimary}}>
            <FlightList />
            </div>
            </div>
         </div>
         
        );
    }
/*
FaAngellist 
FaLine
{ sprintf ('%s', lines) }
<FlightList />
//alert ( pilot.callsign + ' ' + pilot.name ); // { <h3 style={{color: theme.textPrimary}}>HALLO</h3>  }
                // {
                // if ( pilotData ) 
                //     pilotData.forEach((pilot, index) => {
                //         // if (pilot) {
                //         // // Check if pilot does have a departure airport
                //         // if(pilot.dep && pilot.dep.code.icao) {
                //         //     const depIcao = pilot.dep.code.icao;
                            
                //         //     // If the airport does not exists in our javascript object, we initalize it.
                //         //     if (!activeAirports[depIcao]){
                //         //     activeAirports[depIcao] = {}
                //         //     }
                
                //         //     // Insert the index to the appropriate array OR initalize it if it doesn't exist.
                //         //     activeAirports[depIcao].dep ? activeAirports[depIcao].dep.push(index) : activeAirports[depIcao].dep = [index];
                //         // }
                
                //         // // Now we do the same thing, but for the arrival airport.
                //         // if(pilot.arr && pilot.arr.code.icao) {
                //         //     const arrIcao = pilot.arr.code.icao;
                
                //         //     if (!activeAirports[arrIcao]){
                //         //     activeAirports[arrIcao] = {}
                //         //     }
                
                //         //     activeAirports[arrIcao].arr ? activeAirports[arrIcao].arr.push(index) : activeAirports[arrIcao].arr = [index];
                //         // }
                //         // }
                //     });
                // }

*/                
    // handleSwitch1 = (checked) => {
    //     this.setState({ settings: { ...this.state.settings, switch1: checked }});
    // }
}

/*
                // sprintf ('Name%s', 'START')

                pilots.forEach((pilot, index) => {  
                    '<div>WERT</div>'  
                   })
*/              
  

// const FormSwitch = ({title, onChange, checked, subSection, isDarkMode}) => {

//   let style = switchStyle;
//   if (subSection) {
//     style = subSwitchStyle
//   }
//   if (isDarkMode) {
//     style = {...style, ...darkSwitchStyle}
//   }

//   return (
//     <FormGroup style={{display: "flex", justifyContent: "space-between"}}>
//       <label htmlFor={title.split(' ').join('-')}>{title}</label>
//       <div id={title.split(' ').join('-')}>
//           <Switch onChange={onChange} checked={checked} {...style}/>
//       </div>
//     </FormGroup>
//   )
// }

// const switchStyle = {
//     onColor: "#86d3ff",
//     onHandleColor: "#2693e6",
//     handleDiameter: 20, // Kreisdruchmesser Schieberegler
//     uncheckedIcon: false,
//     checkedIcon: false,
//     boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.6)",
//     activeBoxShadow: "0px 0px 1px 10px rgba(0, 0, 0, 0.2)",
//     height: 20,
//     width: 40,
// }

// const darkSwitchStyle = {
//   onColor: '#666666',
//   offColor: '#333333',
//   onHandleColor: '#000',
//   offHandleColor: '#000',
// }

// const subSwitchStyle = {
//   ...switchStyle,
//   handleDiameter: 15,
//   height: 15,
//   width: 30,
// }



const mapStateToProps = (state) => ({
    error: getAllAircraftError(state),
    allAircraft: getAllAircraft(state),
  
})

const mapDispatchToProps = {
 
   fetchAllData: fetchAllAircraftDataAction,
//   toggleColorMode,
//   toggleAirportMarkerATCBadges,
//   toggleAirportMarkerApproachCircle,
//   toggleAirportMarkers,
 }


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PilotList)